import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Card from "../designSystem/b-molecules/cards/Card";
import TitleBar from "../designSystem/c-organism/titleBar/TitleBar";
import SettingsDialog from "./components/SettingsDialog";
import style from "./Home.module.css";
import { canManageAccess } from "../utils/permissions";

const Home = () => {
  const navigate = useNavigate();
  const org = useSelector((state) => state.orgStatus.value);
  const userStatus = useSelector((state) => state.userStatus.value);
  const [user, setUser] = useState(null);
  const [canEdit, setCanEdit] = useState(false);
  const [showSettingsDialog, setShowSettingsDialog] = useState(false);

  // Get current user
  useEffect(() => {
    if (userStatus) {
      setUser(JSON.parse(userStatus.payload));
    }
  }, [userStatus]);

  // Check if user can access settings (admin only)
  useEffect(() => {
    if (user && org?.payload) {
      // Settings access is for admins only
      setCanEdit(canManageAccess(user, org.payload));
    } else {
      setCanEdit(false);
    }
  }, [user, org?.payload]);

  function goToJourneys() {
    navigate("/journeys");
  }
  function goToPersonas() {
    navigate("/personas");
  }
  function goToInsights() {
    navigate("/insights");
  }

  const actions = [];
  if (canEdit) {
    actions.push({
      icon: "settings",
      name: "",
      action: () => setShowSettingsDialog(true),
      variants: ["text"]
    });
  }

  return (
    <div className="mainContentInner">
      <TitleBar
        title="Home"
        actions={actions}
        breadcrumb={[]}
      />
      <div className="contentPadding">
        <div className={style.home}>
          <Card
            title="Journeys"
            text="Map out your key journeys"
            image={require("../assets/images/journeymaps.png")}
            ctas={[
              {
                name: "Go",
                onClick: () => goToJourneys(),
              },
            ]}
            variants={["white"]}
          />
          <Card
            title="Insights"
            text="Analyze customer feedback, explore trends, and ask questions"
            image={require("../assets/images/customer-data.png")}
            ctas={[
              {
                name: "Go",
                onClick: () => goToInsights(),
              },
            ]}
            variants={["white"]}
          />
          <Card
            title="Personas"
            text="Who are your customers?"
            image={require("../assets/images/personas.png")}
            ctas={[
              {
                name: "Go",
                onClick: () => goToPersonas(),
              },
            ]}
            variants={["white"]}
          />
        </div>
      </div>

      <SettingsDialog
        show={showSettingsDialog}
        onClose={() => setShowSettingsDialog(false)}
      />
    </div>
  );
};

export default Home;
